<template>
  <div>
     <login @login="login"></login>
     <hr class="my-1"/>
     <small class="text-center py-1 float-right">Nu ai cont Hello Holidays? <router-link :to="{ name: 'Public/Subscribe' }" class="link"> inregistreaza-te aici</router-link> </small>
  </div>
</template>

<script>
import auth from 'b2b-common/services/auth'
import login from '@/shared/components/login'

import toast from 'b2b-common/mixins/toast'

export default {
  components: { login },
  mixins: [toast],
  methods: {
    login ({ client, username, password }) {
      auth.login({ client, username, password })
        .then(res => {
          if (res) {
            this.addToast({ message: 'Bine ati venit', title: 'Login', variant: 'success' })
            this.$router.push({ name: 'Private/Default' })
          } else {
            this.addToast({
              message: 'Va rugam verificati datele introduse in formular. Cod client, nume utilizator sau parola sunt invalide.',
              title: 'Login invalid',
              variant: 'danger'
            })
          }
        }).catch(() => {
          this.addToast({ message: 'Formular invalid', title: 'Login invalid', variant: 'danger' })
        })
    }
  }

}
</script>
